import React, { useEffect, useState } from "react";
import styles from "./savior.module.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import StarContainer from "../../components/star-container/star-container";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchBox from "../../components/search-box/search-box";
import FilterSelect from "../../components/filter-select/filter-select";
import { changeFilter } from "../../store/reducers/list/saviorList";
import { selectFilteredSaviors, selectSaviorFilter } from "../../store/selectors/saviorSelectors";
import PortraitWithName from "../../components/savior/portrait/portrait-with-name";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import { v4 } from "uuid";
import SaviorDescModal from "../../components/savior/modal/savior-desc-modal";
import FullScreenModal from "../../components/savior/modal/modal-left/full-screen-modal";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";
import FILTERS from "../../config/filter_config.json";
import SORT_LIST from "../../config/sort_config.json";

export default function Savior() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);

    // const [FILTERS, setFILTERS] = useState(null);
    // const [SORT_LIST, setSORTLIST] = useState(null);

    // useEffect(() => {
    //     loadData("filter_config.json").then(setFILTERS);
    //     loadData("sort_config.json").then(setSORTLIST);
    // }, []);

    const saviorFilter = useSelector(selectSaviorFilter);
    const [query, setQuery] = useState("");
    const filteredSaviors = useSelector((state) => selectFilteredSaviors(state, query));

    const [selected, setSelected] = useState(null);
    const [isActive, setIsActive] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // if (!FILTERS || !SORT_LIST) return;

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.savior")} />
            <div className={styles["savior-container"]}>
                <SearchBox changeQuery={setQuery} placeholder={getUIText(lang, "search.savior")} />
                <div className={styles["filter-wrapper"]}>
                    <FilterSelect
                        id={"rarity"}
                        list={lang === LOCALES.KO ? FILTERS.SAVIOR_RARITY : FILTERS.SAVIOR_RARITY_ENG}
                        selected={saviorFilter.rarity}
                        changeFilter={changeFilter}
                    />
                    <FilterSelect
                        id={"attr"}
                        list={lang === LOCALES.KO ? FILTERS.ATTRIBUTE : FILTERS.ATTRIBUTE_ENG}
                        selected={saviorFilter.attr}
                        changeFilter={changeFilter}
                    />
                    <FilterSelect
                        id={"class"}
                        list={lang === LOCALES.KO ? FILTERS.CLASS : FILTERS.CLASS_ENG}
                        selected={saviorFilter.class}
                        changeFilter={changeFilter}
                    />
                    <FilterSelect
                        id={"order"}
                        list={lang === LOCALES.KO ? SORT_LIST.SAVIOR_SORT : SORT_LIST.SAVIOR_SORT_ENG}
                        showName={false}
                        selected={saviorFilter.order}
                        changeFilter={changeFilter}
                        forceWidth={"120px"}
                    />
                </div>
                <div className={styles["saviors"]}>
                    {filteredSaviors.map((savior) => (
                        <PortraitWithName
                            lang={lang}
                            savior={savior}
                            key={`${v4()}`}
                            onSelect={(savior) => navigate(`/savior/${savior.id}`)}
                        />
                    ))}
                </div>
            </div>
            <ScrollUpButton />
            <Footer />

            <SaviorDescModal lang={lang} isActive={isActive} setIsActive={setIsActive} selected={selected} />
            <FullScreenModal lang={lang} savior={selected} />
        </div>
    );
}
